import React, { useEffect } from "react";
import { connect } from "react-redux";
import {
  getSpecificStepRequest,
  getStepCommentInfoByStepId,
} from "@microdoing/shared/services/userCampaign/actions";

import ActionScreen from "app/scenes/ActionScreen/ActionScreen";

const HistoricalActionScreen = ({
  route,
  getSpecificStepRequest,
  requesting,
  navigation,
}) => {
  useEffect(() => {
    const { stepId } = route.params;
    getSpecificStepRequest(stepId);
    getStepCommentInfoByStepId({ stepId });
  }, [getSpecificStepRequest, route]);

  return <ActionScreen navigation={navigation} hasAction={false} />;
};

const mapStateToProps = state => {
  const { requesting } = state.userCampaign;
  return {
    requesting,
  };
};

export default connect(mapStateToProps, {
  getSpecificStepRequest,
  getStepCommentInfoByStepId,
})(HistoricalActionScreen);
